// project imports
import { authClient } from 'services/restService';
import { logError } from 'services/Logging';

// ==============================|| ACCOUNT THUNKS ||============================== //

export const revokeAccessToken = (
  refreshToken: string | undefined,
  callback?: () => void
) => {
  const data = new URLSearchParams();

  data.append('client_id', 'aiems-gui');
  data.append('grant_type', 'refresh_token');
  data.append('refresh_token', refreshToken || '');

  authClient
    .post('/realms/aiems/protocol/openid-connect/token', data.toString(), {
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
    .then((_response) => {
      callback && callback();
    })
    .catch((err) => {
      logError(err);
    });
};
